import { IMultiLanguageValue } from '../common/interfaces/MultiLanguageValue.interface';
import i18n from 'i18next';

/**
 * Get localized string value from an array of IMultiLanguageValue,
 * falling back to a default language if current language is not found.
 *
 * @param items - array of IMultiLanguageValue
 * @param fallbackLang - fallback language code (default: 'en')
 * @returns localized string or empty string if no match found
 */
export function getLocalizedValueFromMultiLangValues(
  items: IMultiLanguageValue[],
  fallbackLang = 'ar'
): string {
  const currentLang = i18n.language;

  // Try to find the value for the current language
  const found = items.find((item) => item.language === currentLang)?.value;
  if (found) return found;

  // Fallback to default language if not found
  const fallback = items.find((item) => item.language === fallbackLang)?.value;
  return fallback || '';
}
